import { fleetApi } from '../../api/axiosClient';
import { timezone } from '../../utils/timeZone';

const getTzParam = (tz) => {
  const defaultTz = typeof timezone === 'function' ? timezone() : Number(timezone);
  const activeTz =
    tz !== undefined && tz !== null && !isNaN(tz)
      ? Number(tz)
      : !isNaN(defaultTz)
        ? defaultTz
        : Math.abs(new Date().getTimezoneOffset() / 60);
  return `?tz=${activeTz}`;
};

export const filterReportFuelSummary = async (payload, tz) => {
  try {
    const activeTz = tz ?? payload?.tz;
    const response = await fleetApi.post(`/report-fuel-summary${getTzParam(activeTz)}&withoutLogicAllSensor=true`, payload);
    return response;
  } catch (error) {
    console.error('Error fetching fuel summary report:', error);
    throw error;
  }
};
export const datePickerStyle = {
  '& .MuiInputLabel-root': {
    color: '#485D9A',
    '&.Mui-focused': { color: '#485D9A' }
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    }
  }
};
